import arcImage from "../assets/1.png";
import arcImage1 from "../assets/2.png";

/**
 * Applies standard "arc and footer" styles to a jsPDF instance.
 * 
 * @param {Object} pdf - The jsPDF instance
 * @param {string} generatedDate - The date/time the report was generated
 */
export const applyStandardPdfStyles = (pdf, generatedDate) => {
  const pageCount = pdf.internal.getNumberOfPages();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);

    // --- 1. DRAW ARC IMAGES ---
    // Use setGState for opacity if available, otherwise just draw
    try {
        if (pdf.GState) {
            pdf.setGState(new pdf.GState({ opacity: 0.4 }));
        }
        pdf.addImage(arcImage, "PNG", pageWidth - 20, 0, 20, 20);
        pdf.addImage(arcImage1, "PNG", 0, pageHeight - 20, 20, 20);
    } catch (e) {
        console.warn("Failed to add arc images to PDF:", e);
    }

    // --- 2. FOOTER ALIGNMENT ---
    try {
        if (pdf.GState) {
            pdf.setGState(new pdf.GState({ opacity: 1.0 }));
        }
        pdf.setFontSize(8);
        pdf.setTextColor(100);

        pdf.text(
        `Report Generated: ${generatedDate}`,
        pageWidth / 2,
        pageHeight - 5,
        { align: "center" }
        );
        pdf.text(
        `Page ${i} of ${pageCount}`,
        pageWidth - 10,
        pageHeight - 5,
        { align: "right" }
        );
    } catch (e) {
        console.warn("Failed to add footer to PDF:", e);
    }
  }
};
